// Generates an inline SVG thumbnail for projects that have no screenshot yet.
// Returned as a data URI so it can be used anywhere an image src is expected,
// including the HTML that html2pdf renders.

const hueFromString = (value: string) => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % 360;
  }
  return hash;
};

const initialsFrom = (title: string) =>
  title
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");

export const placeholderThumbnail = (title: string, seed = title) => {
  const hue = hueFromString(seed);
  const initials = initialsFrom(title) || "PR";
  const label = title.length > 34 ? `${title.slice(0, 33)}…` : title;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 360" width="640" height="360">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="hsl(${hue} 70% 46%)"/>
      <stop offset="100%" stop-color="hsl(${(hue + 48) % 360} 68% 28%)"/>
    </linearGradient>
  </defs>
  <rect width="640" height="360" fill="url(#g)"/>
  <circle cx="548" cy="58" r="150" fill="rgba(255,255,255,0.08)"/>
  <circle cx="96" cy="318" r="110" fill="rgba(0,0,0,0.12)"/>
  <text x="320" y="188" text-anchor="middle" font-family="Inter, Helvetica, Arial, sans-serif" font-size="120" font-weight="700" fill="rgba(255,255,255,0.92)">${initials}</text>
  <text x="320" y="248" text-anchor="middle" font-family="Inter, Helvetica, Arial, sans-serif" font-size="26" font-weight="500" fill="rgba(255,255,255,0.78)">${label
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")}</text>
</svg>`;

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};
